import { render } from "./EnrollmentChargeContent.vue?vue&type=template&id=77a5ff9a&ts=true"
import script from "./EnrollmentChargeContent.vue?vue&type=script&lang=ts"
export * from "./EnrollmentChargeContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__